<template>
  <div>
    <v-btn
      v-if="!infoDelegation.delegate_collaboratorname"
      :elevation="0"
      rounded
      color="primary"
      @click="dialog = true"
      class="float-left"
      v-html="$t('delegate-task-dial.cta')"
      :disabled="status === 'sent' || status === 'verify' ? true : false"
    ></v-btn>

<!-- <v-btn
            text
            color="error"
            @click="dialog = false"
          > -->
    <v-btn
      v-else-if="infoDelegation.delegate_collaboratorname"
      :elevation="0"
      rounded
      outlined
      color="error"
      @click="revokeDelegate"
      class="float-left"
      v-html="$t('delegate-task-dial.cta-revoke', 1, {staff: delegateStaffName})"
      :disabled="status === 'sent' || status === 'verify' ? true : false"
    ></v-btn>

    <v-dialog
      v-model="dialog"
      max-width="500"
    >
      <v-card class="ma-0">
        <v-card-title class="headline">
          <template v-if="content && content.length > 0">
            <template v-for="(item, index) in content">
              <div v-if="item.type === 'title' && item.text" :key="index" class="headline" v-html="item.text"></div>
            </template>
          </template>
        </v-card-title>

        <v-card-text>
          <template v-if="content && content.length > 0">
            <template v-for="(item, index) in content">
              <p v-if="item.type === 'text' && item.text" :key="index">
                <pre v-html="item.text"></pre>
              </p>
            </template>
          </template>

          <v-divider class="mb-3"></v-divider>
          <template v-if="staffs && staffs.length > 0">
            <v-radio-group
              v-model="selectedStaff"
              column
            >
              <v-radio
                v-for="staff in staffs"
                :key="staff.id"
                :label="unescaped(staff.title)"
                :value="staff"
              ></v-radio>
            </v-radio-group>
          </template>
          <!-- If no staffs found -->
          <template v-else>
            <h2 class="mb-3" v-html="$t('delegate-task-dial.nostaff-description')"></h2>
            <div class="text-center">
              <v-btn
                outlined
                rounded
                small
                color="primary"
                to="/profile"
              >
                {{$t('delegate-task-dial.nostaff-btn')}}
              </v-btn>
            </div>
          </template>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            rounded
            text
            color="error"
            @click="dialog = false"
          >
            {{ $t('delegate-task-dial.btn-1') }}
          </v-btn>
          <v-btn
            v-if="staffs"
            outlined
            rounded
            color="primary"
            @click="delegateStaff"
          >
            {{ $t('delegate-task-dial.btn-2') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <HTTPresponse :alert="httpalert" @changeHTTPBoxState="HTTPState"></HTTPresponse>
    <v-snackbar
      v-model="snackbar.status"
      color="#161520"
      :timeout="6000"
      top
      multi-line
    >
      <span v-html="snackbar.text"></span>
      <v-btn
        dark
        text
        :color="snackbar.color"
        @click="snackbar.status = false"
      >
        {{ $tc("delegate-task-dial.snackbar.close") }}
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { staffList } from '@/js/staff/staffList'
import { delegate } from '@/js/delegate/delegate'
import { delegateRevoke } from '@/js/delegate/delegateRevoke'
import { getStatic } from '@/js/static/getStatic'
import HTTPresponse from '@/components/app/HTTPresponse'

export default {
  props: {
    answerid: String,
    sequenceid: String,
    infoDelegation: Object|Array,
    status: String
  },
  components: {
    HTTPresponse: HTTPresponse
  },

  data () {
    return {
      dialog: false,
      staffs: null,
      selectedStaff: null,
      snackbar: {
        status: false,
        text: this.$t("delegate-task-dial.snackbar.text-error"),
        color: 'error'
      },
      content: null,
      httpalert: false
    }
  },

  created () {
    // if (!this.$store.getters['auth/isAuthenticated']) return

    staffList(this.$store.state.auth.token)
      .then(response => {
        this.staffs = response
      })
      .catch(() => {
        this.httpalert = true
        setTimeout(() => {
          this.httpalert = false
        }, 4000)
      })

    const params ={
      lang: this.$i18n.locale ? this.$i18n.locale : 'en',
      keyword: 'popupdelegation'
    } 
    getStatic(params)
      .then(response => this.content = response.modules)
      // .catch(() => {
      //   this.httpalert = true
      //   setTimeout(() => {
      //     this.httpalert = false
      //   }, 4000)
      // })
  },

  computed: {
    delegateStaffName() {
      return this.infoDelegation.delegate_collaboratorname
    }
  },

  methods: {
    delegateStaff () {
      // if (!this.$store.getters['auth/isAuthenticated']) return

      const params = {
        answerid : this.answerid,
        collaboratorid : this.selectedStaff.id,
        sequenceid : this.sequenceid,
        key : this.$store.state.auth.token
      }
      delegate(params)
        .then(response => {
          console.log(response)
          if (response.data.status === 'ok') {
            this.snackbar.status = true
            this.snackbar.text = this.$tc("delegate-task-dial.snackbar.text-success", 1,
                                          {staff: this.selectedStaff.title})
            this.snackbar.color = 'success'
            this.$emit('reloadSequence')
          }
          // else if error
          else {
            this.snackbar.status = true
            this.snackbar.text = this.$t("delegate-task-dial.snackbar.text-error")
            this.snackbar.color = 'error'
          }
        })
        .catch(() => {
          this.snackbar.status = true
          this.snackbar.text = this.$t("delegate-task-dial.snackbar.text-error")
          this.snackbar.color = 'error'
        })

      this.dialog = false
    },

    revokeDelegate () {
      // if (!this.$store.getters['auth/isAuthenticated']) return

      const params = {
        collaboratorid : this.infoDelegation.delegate_collaboratorid,
        delegationkey : this.infoDelegation.delegate_key,
        key : this.$store.state.auth.token
      }
      delegateRevoke(params)
        .then(response => {
          if (response.data.status === 'ok') {
            this.snackbar.status = true
            this.snackbar.text = this.$tc("delegate-task-dial.snackbar.text-revoke-success", 1,
                                          {staff: this.infoDelegation.delegate_collaboratorname})
            this.snackbar.color = 'success'
            this.$emit('reloadSequence')
          }
          // else if error
          else {
            this.snackbar.status = true
            this.snackbar.text = this.$t("delegate-task-dial.snackbar.text-error")
            this.snackbar.color = 'error'
          }
        })
        .catch(() => {
          this.snackbar.status = true
          this.snackbar.text = this.$t("delegate-task-dial.snackbar.text-error")
          this.snackbar.color = 'error'
        })
    },

    HTTPState (value) {
      this.httpalert = this.value
    },
    unescaped (string) {
      var txt = document.createElement('textarea')
      txt.innerHTML = string
      return txt.value
    },
  }
}
</script>
